module.exports = __webpack_public_path__ + "img/logo-myers.a488b8a5.svg";